module.exports = __webpack_public_path__ + "media/images/fallback/figures/default_article_image_2-a29ffe935101b2bba00b052e0b32468a.png";